import React, { Component } from 'react';
import { PaddedSection, ClientTile } from '../../atoms';

import './styles.css';

/**
 * A template for landing page clients section
 *
 * @typedef {Object} Props
 * @prop {Array} clients
 * @prop {String} heading
 *
 * @augments {Component<Props>}
 */
export default class OurClients extends Component {

	genClient = (clients = []) => clients.map((client) => <ClientTile key={client.imageName} {...client} />)

	render () {
		const { clients, heading } = this.props;
		return (
			<PaddedSection className='OurClients'>
				<h1>{heading}</h1>
				<div className='OurClients-clents'>
					{this.genClient(clients)}
				</div>
			</PaddedSection>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/templates/OurClients/OurClients.js